const storage = {
    not_configured: 'Провайдер хранилища не настроен.',
    missing_parameter: 'Отсутствует параметр {{parameter}} для провайдера хранилища.',
    upload_error: 'Не удалось загрузить файл в провайдер хранилища.',
    download_error: 'Failed to download file from the storage provider.',
};
export default Object.freeze(storage);
